<template>
  <div>
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="col-md-12">
          <div class="page-header bordered mb0">
            <div class="row">
              <div class="col-md-8">
                <h1>
                  {{ event.title }}
                  <small v-if="event.sold_out" class="sold-out sold-out-custom">
                    (Sold out!)
                  </small>
                  <small v-if="!event.event_available" class="sold-out sold-out-custom">
                    (Not available)
                  </small>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="content" class="item-single">
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="col-md-12">
            <div class="row justify-content-md-center has-sidebar">
              <div class="col-md-7 col-lg-8">
                <div>
                  <div v-if="event.image_url" class="item-gallery">
                    <div v-if="event.sold_out" class="item-badges-show">
                      <div class="item-badge-left">Sold out!</div>
                    </div>
                    <div v-if="!event.event_available" class="item-badges-show">
                      <div class="item-badge-left">Not available</div>
                    </div>

                    <img :src="event.image_url" class="img-fluid">
                  </div>

                  <div v-else class="text-center">
                    <i class="fa fa-picture-o without-image" aria-hidden="true"></i>
                  </div>

                  <div>
                    <div class="item-description">
                      <h3 class="headline">
                        Show Description
                        <small>
                          ({{ event.event_type }} - {{ event.topic }})
                        </small>
                      </h3>
                      <div v-html="markedText(event.description)">
                      </div>
                    </div>

                    <h3 class="headline">Organizer Details</h3>
                    <strong> {{ event.organizer_name }} </strong> <br/>
                    <p> {{ event.organizer_description }} </p>

                    <template v-if="event.organizer_website">
                      <a :href="event.organizer_website" target="_blank">
                        {{ event.organizer_website }}
                      </a>
                      <br/>
                    </template>

                    <template v-if="event.organizer_contact_phone_number">
                      <a :href="`tel:+1${extracNumbers(event.organizer_contact_phone_number)}`"
                        rel="nofollow">
                        {{ event.organizer_contact_phone_number }}
                      </a>
                      <br/>
                    </template>

                    <template v-if="event.organizer_facebook_id">
                      <a :href="socialMediaLinks(event.organizer_facebook_id, 'facebook')"
                        target="_blank">
                        <i class="fa fa-facebook-official" aria-hidden="true"></i>
                        {{ event.organizer_facebook_id }}
                      </a>
                      <br/>
                    </template>

                    <template v-if="event.organizer_twitter_id">
                      <a :href="socialMediaLinks(event.organizer_twitter_id, 'twitter')"
                        target="_blank">
                        <i class="fa fa-twitter" aria-hidden="true"></i>
                        {{ event.organizer_twitter_id }}
                      </a>
                      <br/>
                    </template>

                    <template v-if="event.organizer_instagram_id">
                      <a :href="socialMediaLinks(event.organizer_instagram_id, 'instagram')"
                        target="_blank">
                        <i class="fa fa-instagram" aria-hidden="true"></i>
                        {{ event.organizer_instagram_id }}
                      </a>
                      <br/>
                    </template>

                    <h3 class="headline">Policy Refund</h3>
                    <p>
                      {{ event.policy_refund }}
                    </p>

                    <b-button v-b-modal.formContactModal class="btn btn-lg btn-primary btn-block">
                      Contact Us
                    </b-button>

                    <ContactEventForm
                      :event="event">
                    </ContactEventForm>
                  </div>
                </div>
              </div>

              <div class="col-md-5 col-lg-4">
                <div id="sidebar" class="sidebar-right">
                  <div class="sidebar_inner">
                    <div id="feature-list" role="tablist">
                      <div class="card">
                        <div class="card-header" role="tab" id="headingOne">
                          <h4 class="panel-title">
                            <i class="fa fa-calendar"></i> Date and Time
                          </h4>
                        </div>
                        <div class="panel-collapse collapse show" role="tabpanel">
                          <div class="card-body">
                            <p>
                              {{ getEventFullDateTime(event) }}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="card">
                        <div class="card-header" role="tab" id="headingOne">
                          <h4 class="panel-title">
                            <i class="fa fa-map-marker"></i> Location
                          </h4>
                        </div>
                        <div class="panel-collapse collapse show" role="tabpanel">
                          <div class="card-body">
                            <p>
                              <div v-html="getEventFullAddress(event)">
                              </div>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="card">
                        <h5 class="subheadline mt-0  mb-0">
                          <i class="fa fa-ticket" aria-hidden="true"></i> Tickets
                        </h5>
                        <div v-if="eventSoldOut">
                          <a href="javascript:;" class="btn btn-primary btn-block disabled">
                            Sold Out
                          </a>
                        </div>
                        <div v-else-if="!event.event_available">
                          <a href="javascript:;" class="btn btn-primary btn-block disabled">
                            Not available
                          </a>
                        </div>
                        <div v-else>
                          <div class="media">
                            <div class="media-body">
                              <p v-for="(ticket) in event.tickets_attributes" :key="ticket.id"
                                v-show="showTicket(ticket)">
                                {{ (ticket.description || 'N/A') + ' (' + ticket.formatted_price_with_fee + ')' }}
                                <span v-show="displayRemainingTickets(ticket, event)">
                                  {{ remainingTickets(ticket.on_sale) }}
                                </span>
                              </p>
                            </div>
                          </div>
                          <b-button v-b-modal.ticketSelectionModal class="btn btn-lg btn-primary btn-block">
                            Buy Ticket
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <TicketSelectionModal
      :tickets="event.tickets_attributes || []"
      :event="event"
      :applicationSettings="applicationSettings"
      :showRemainingTickets="event.show_remaining_tickets"
      :showRemainingTicketsSince="event.show_remaining_tickets_since"
      @show-ticket="showTicket"
    />
    <script v-html="eventStructuredData" type="application/ld+json" />
  </div>
</template>

<script>
import ContactEventForm from '../common/ContactForm'
import TicketSelectionModal from './tickets/TicketSelectionModal'
import StructuredData from '../common/StructuredData'
import GA from '../common/GA'

export default {
  name: 'EventShow',
  mixins: [StructuredData, GA],
  components: {
    ContactEventForm,
    TicketSelectionModal
  },
  data: function () {
    return {
      event: this.$route.params.event || {
        event_dates_attributes: [{}],
        needLoading: true,
        accept_giftcards: false
      },
      showTicketSelectionModal: this.$route.params.showTicketSelectionModal,
      eventSoldOut: true,
      applicationSettings: {
        TICKET_FEE: {
          value: 0
        }
      },
      eventStructuredData: {},
      eventId: this.$route.params.id,
      pagePath: this.$router.currentRoute.fullPath
    }
  },
  created () {
    this.loadGAIdByEventId(this.eventId)
    this.loadEventStructuredData(this.eventId)
    this.getApplicationSettings()

    if (this.event.needLoading) {
      this.loadEvent()
    } else {
      this.setTickets()
    }
  },
  mounted () {
    if (this.showTicketSelectionModal) {
      this.$bvModal.show('ticketSelectionModal')
    }
  },
  head () {
    if (!this.event.needLoading) {
      return {
        meta: this.dynamicMetaTags(),
        script: this.gaTagBuilder
      }
    } else {
      return []
    }
  },
  methods: {
    setTickets () {
      let self = this
      this.event.tickets_attributes.forEach(function (ticket) {
        ticket['selected'] = false

        if (!ticket.sold_put) {
          self.eventSoldOut = false
        }
      })
    },
    showTicket (ticket) {
      return (this.$root.logged === true && this.$localStorage.get('user_type').match(/admin|client_admin|staffer/) && ticket.wait_list === true) || (ticket.wait_list !== true)
    },
    getApplicationSettings () {
      var self = this

      this.$http.get('/application_settings').then(function (response) {
        response.data.forEach(function (appSetting, index) {
          self.applicationSettings[appSetting.name] = {
            value: appSetting.value,
            id: appSetting.id
          }
        })
      })
    },
    loadEvent () {
      var self = this
      var loader = this.$loading.show()

      this.$http.get('public_access/events/' + this.$route.params.id).then(function (response) {
        self.event = response.data
        self.event.needLoading = false
        self.setTickets()
        self.$emit('updateHead')
      }).finally(function () {
        loader.hide()
      })
    },
    dynamicMetaTags () {
      return [
        { property: 'og:title', content: this.event.title, id: 'og-title' },
        { property: 'og:image', content: this.event.image_url, id: 'og-image' },
        { property: 'og:type', content: 'website', id: 'og-type' },
        { property: 'og:url', content: window.location.href, id: 'og-url' }
      ]
    }
  }
}
</script>
